import { MdSupportAgent } from "react-icons/md";
import expert1 from "../../../assets/imgs/home/experts/chuyen-gia-01.png";
import expert2 from "../../../assets/imgs/home/experts/chuyen-gia-02.png";
import expert3 from "../../../assets/imgs/home/experts/chuyen-gia-03.png";
import expert4 from "../../../assets/imgs/home/experts/chuyen-gia-04.png";
import expert5 from "../../../assets/imgs/home/experts/chuyen-gia-05.png";
import expert6 from "../../../assets/imgs/home/experts/chuyen-gia-06.png";
import expert7 from "../../../assets/imgs/home/experts/chuyen-gia-07.png";
import expert8 from "../../../assets/imgs/home/experts/chuyen-gia-08.png";

import "./ExpertsSaySection.css";

const expertsData = [
  {
    name: "PGS.TS Võ Thành Danh",
    title: "Nguyên Trưởng Khoa Kinh Tế Đại Học Cần Thơ",
    quote: "Chuyên gia kinh tế",
    avatar: expert1,
  },
  {
    name: "PGS.TS Lưu Thanh Đức Hải",
    title: "Phó Trưởng Khoa Kinh Tế Đại Học Cần Thơ",
    quote: "Chuyên gia kinh tế",
    avatar: expert2,
  },
  {
    name: "PGS.TS Phan Đình Khôi",
    title: "Trưởng bộ môn tài chính ngân hàng khoa kinh tế, ĐHCT",
    quote: "Chuyên gia kinh tế",
    avatar: expert3,
  },
  {
    name: "PSG.TS Huỳnh Việt Khải",
    title:
      "Trưởng bộ môn kinh tế môi trường và tài nguyên thiên nhiên, Khoa kinh tế, ĐHCT",
    quote: "Chuyên gia kinh tế",
    avatar: expert4,
  },
  {
    name: "Tiến Sĩ Lê Văn Tư",
    title: "SEO, Công Ty TNHH Khởi Nghiệp Hoa Sinh Tân HD",
    quote: "Chuyên gia SEO, Tư vấn chiến lược kinh doanh",
    avatar: expert5,
  },
  {
    name: "Tiến Sĩ Hoàng Long",
    title: "Đại học RMIX Việt Nam",
    quote: "Giảng viên Đại học RMIX",
    avatar: expert7,
  },
  {
    name: "Thầy Nguyễn Trí Thức",
    title:
      "Trưởng Bộ Phận đài truyền hình việt nam, Giảng viên đại học sân khấu điện ảnh TP.HCM, Giảng viên Đại Học Hoa Sen",
    quote: "Chuyên gia truyền thông, Giảng viên",
    avatar: expert6,
  },
  {
    name: "Thầy Nguyễn Hoài Anh",
    title:
      "CEO, Founder Design24 GĐ CTY TNHH Mekogone, Giảng Viên ĐH Quốc Tế Hồng Bàng, FPT, Aptech, ... Trưởng bộ phận TKĐH Đài Truyền Hình Hậu Giang",
    quote: "Chuyên gia thiết kế đồ họa, Giảng viên",
    avatar: expert8,
  },
];

const ExpertsSaySection = () => {
  return (
    <section className="experts">
      <div className="experts__container">
        <div className="experts__icon">
          <MdSupportAgent />
        </div>
        <h2 className="experts__title">Ban chuyên gia cố vấn - đào tạo</h2>
        <div className="experts__cards">
          {expertsData.map((expert, index) => (
            <div
              className="experts__card"
              key={index}
            >
              <div className="experts__info">
                <p className="experts__info-quote">“{expert.title}”</p>
                <p className="experts__info-name">{expert.name}</p>
                <p className="experts__info-title">{expert.quote}</p>
              </div>
              <img
                src={expert.avatar}
                alt={expert.name}
                className="experts__avatar"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertsSaySection;
